import React, { useEffect } from "react";
import styles from './styles.module.css';
import { useLocation } from "react-router-dom";
import { setMetaTags, getDataFromRoutes } from "../../utils/util_functions";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { useDispatch } from "react-redux";
import { ROUTES_CONST } from "../../utils/constants";



const About = () => {

  const location = useLocation();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  const {
    title, metaTitle
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);

  useEffect(() => {
    setMetaTags(metaTitle);
    // eslint-disable-next-line
  }, []);

  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);


  return (
    <main className='main'>
      <h1 className="title">{title}</h1>
      <div className={styles.container}>
        <p className="text text__align">&emsp;&emsp;
          Основное  направление  научно-производственной  группы  компаний
          «Омега-Мера» - разработка, производство, поставка контрольно-измерительных
          приборов для измерения расхода и учета жидкостей и энергоресурсосбережения:
          расходомеров-счетчиков  воды  и  технологических  жидкостей,  счетчиков  тепла,
          вспомогательного оборудования.
        </p>
        <p className="text text__align">&emsp;&emsp;
          Работая на рынке измерительных приборов с 2002 года, мы накопили большой
          опыт разработки приборов измерения расхода. Потребители высоко оценивают
          нашу продукцию, что позволяет даже в условиях высокой конкуренции постоянно
          наращивать  продажи,  инвестируя  прибыли  в  развитие  компании,  новые
          разработки, современное оборудование и технологии.
        </p>
        <p className="text text__align">&emsp;&emsp;
          Системный  подход  к  производству,  современная  производственная  и
          метрологическая  база,  сотрудничество  с  европейскими  компаниями
          (оборудование, обучение кадров) гарантируют высокий уровень эксплуатационной
          надежности наших приборов и точность измерений.
        </p>
        <p className="text text__align">&emsp;&emsp;
          Непрерывный  поиск  новых  технологических  решений  и  широкое  внедрение
          собственных  разработок,  использование  современного  метрологического
          оборудования  производства  фирмы  ENBRA  –  признанного  лидера  в  области
          измерения  расхода  в  странах  Восточной  Европы,  позволяют  непрерывно
          наращивать  производственные  мощности  и  увеличивать  спектр  и  объемы
          выпускаемой продукции.
        </p>
        <p className="text text__align">&emsp;&emsp;
          Разработанные  и  серийно  производимые  нами  расходомеры-счетчики  воды  и
          теплосчетчики  отвечают  всем  современным  требованиям  к  данной  продукции
          и  внесены  в  Государственные  реестры  средств  измерений  России,  Казахстана,
          Белоруссии.
        </p>
      </div>
    </main>
  );
};

export default About;
